export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PLAN_TYPES = {
    ONLINE: "online",
    OFFLINE: "offline"
}
